<ng-container *ngIf="canCreateMode || canUpdateMode || canReadMode">
  <form (ngSubmit)="save()" [formGroup]="form">
    <mat-dialog-content class="flex flex-col" [class]="showGouvSearch && hasSearchedGouv ? 'md:overflow-hidden' : ''">
      <!-- Recherche entreprise (API Recherche d'Entreprises — data.gouv.fr, PRED-3215).
          État 1 : modale compacte, recherche au-dessus de la fiche (saisie libre possible).
          État 2 : après recherche, la modale s'élargit et les résultats s'affichent à gauche.
          Sous md (960px) tout passe en layout empilé « téléphone » avec le scroll unique de la
          modale ; au-delà, résultats/fiche côte à côte avec scrolls indépendants. -->
      <ng-container *ngIf="showGouvSearch">
        <div class="flex-shrink-0" [formGroup]="gouvSearchForm" (keydown.enter)="$event.preventDefault(); searchGouv()">
          <div class="flex items-baseline justify-between mb-2">
            <span class="text-base font-medium">1 - Assistant de recherche</span>
            <span class="text-xs text-hint">Source : API data.gouv.fr</span>
          </div>
          <div class="flex flex-col md:flex-row md:items-baseline md:gap-3">
            <base-form-input class="flex-auto" label="Dénomination, SIREN ou SIRET" controlName="q"></base-form-input>
            <base-form-input class="w-full md:w-40" label="Code postal" controlName="codePostal"></base-form-input>
            <base-form-input class="w-full md:w-40" label="Ville" controlName="ville"></base-form-input>
            <base-form-input
              class="w-full md:w-40"
              label="N° de Département"
              controlName="departement"
            ></base-form-input>
            <base-form-input
              class="w-full md:w-40"
              label="Activité (NAF/APE)"
              controlName="activitePrincipale"
            ></base-form-input>
            <button
              type="button"
              mat-raised-button
              color="primary"
              [disabled]="gouvHasNoCriteria || gouvLoading"
              (click)="searchGouv()"
            >
              RECHERCHER
            </button>
          </div>
        </div>
        <mat-divider class="mb-4 flex-shrink-0"></mat-divider>
        <div class="text-base font-medium mb-3 flex-shrink-0">
          {{ hasSearchedGouv ? '2 - Sélection du choix (choix unique)' : '1 - Saisie manuelle' }}
        </div>
      </ng-container>

      <div
        class="flex flex-col md:flex-row items-stretch"
        [class]="showGouvSearch && hasSearchedGouv ? 'md:flex-auto md:min-h-0' : ''"
      >
        <!-- État 2 : résultats de la recherche, sélection = toute la carte.
             Empilé : bloc pleine largeur au-dessus de la fiche ; md+ : colonne de gauche
             (max-w : la modale est plafonnée à 80vw, la fiche garde au moins la moitié de la place). -->
        <div
          class="flex flex-col flex-none min-w-0 min-h-0 border-b mb-3 md:w-[480px] md:max-w-[45%] md:mr-5 md:pr-5 md:border-b-0 md:border-r md:mb-0"
          *ngIf="showGouvSearch && hasSearchedGouv"
        >
          <!-- Empilé : hauteur plafonnée pour que la fiche reste accessible sans dérouler toute la liste. -->
          <div class="flex-1 min-h-0 overflow-y-auto max-h-[260px] md:max-h-[none]" #gouvResultsList>
            <div
              class="flex gap-3 items-start px-3 py-2 border-b border-l-3 cursor-pointer hover:bg-hover"
              *ngFor="let company of gouvResults"
              [class]="
                company.siret === selectedGouvSiret ? 'border-l-primary bg-primary-light' : 'border-l-transparent'
              "
              (click)="selectGouvCompany(company)"
            >
              <span class="gouv-radio" [class.sel]="company.siret === selectedGouvSiret"></span>
              <div class="min-w-0">
                <div class="text-sm font-semibold flex items-center gap-2">
                  {{ company.label }}
                  <span
                    class="text-xs font-semibold px-2 rounded-full"
                    [class]="company.actif ? 'text-green bg-green-light' : 'text-red bg-red-light'"
                  >
                    {{ company.actif ? 'Actif' : 'Fermé' }}
                  </span>
                </div>
                <div class="text-xs text-secondary mt-1">
                  SIRET
                  <b>{{ formatSiret(company.siret) }}</b>
                  <ng-container *ngIf="company.codeApe">· APE {{ company.codeApe }}</ng-container>
                </div>
                <div class="text-xs text-secondary">
                  {{ company.address?.street }}
                  <ng-container *ngIf="company.address?.street">,</ng-container>
                  {{ company.address?.postalCode }} {{ company.address?.city }}
                </div>
              </div>
            </div>
            <div class="text-sm text-secondary py-4 px-1" *ngIf="!gouvResults.length && !gouvLoading">
              Aucune entreprise ne répond aux critères.
            </div>
          </div>
          <button
            type="button"
            mat-button
            color="primary"
            *ngIf="canLoadMoreGouv"
            [disabled]="gouvLoading"
            (click)="loadMoreGouv()"
          >
            AFFICHER PLUS DE RÉSULTATS
          </button>
        </div>

        <!-- Fiche fournisseur : préremplie depuis la sélection, toujours modifiable -->
        <div
          class="flex flex-col min-w-0 flex-auto"
          [class]="showGouvSearch && hasSearchedGouv ? 'md:overflow-y-auto md:min-h-0 md:pr-1' : ''"
        >
          <ng-container *ngIf="showGouvSearch && hasSearchedGouv">
            <div class="text-base font-medium">3 - Fournisseur</div>
            <div class="text-xs text-secondary mb-3">
              Pré-rempli depuis la sélection — modifiable, ou saisie libre sans sélection
            </div>
          </ng-container>

          <base-form-input
            label="Type"
            type="select"
            [items]="supplierType"
            controlName="type"
            [disabled]="isReadMode() || isLinkedInternSupplier"
          ></base-form-input>

          <base-form-input
            label="Dénomination"
            controlName="label"
            [disabled]="isReadMode() || isLinkedInternSupplier"
          ></base-form-input>

          <base-form-input
            *ngIf="isExterne && isFrench"
            label="Nom commercial"
            controlName="commercialName"
            [disabled]="isReadMode()"
          ></base-form-input>

          <!--            <base-form-input-->
          <!--                *ngIf='!isIntern'-->
          <!--                label='N° TVA'-->
          <!--                controlName='tva'>-->
          <!--            </base-form-input>-->

          <base-form-input
            *ngIf="showSubsidiarAccount"
            label="Compte auxiliaire comptable"
            controlName="subsidiarAccount"
            [disabled]="isReadMode()"
          ></base-form-input>

          <base-form-input
            *ngIf="isExterne && isFrench"
            label="N° Siren"
            controlName="sirenNumber"
            invalidPatternMessage="Le format du N°Siren est invalide."
            [disabled]="isReadMode()"
          ></base-form-input>

          <base-form-input
            *ngIf="isExterne && isFrench"
            label="N° Siret"
            controlName="siretNumber"
            [disabled]="isReadMode()"
          ></base-form-input>

          <base-form-input
            class="mb-2"
            *ngIf="isExterne"
            label="Soumis à TVA"
            controlName="submittedToTva"
            type="checkbox"
            [disabled]="isReadMode()"
          ></base-form-input>

          <base-form-input
            *ngIf="isExterne"
            [disabled]="isReadMode() || !submittedToTva"
            label="N° TVA intracom"
            controlName="tva"
            invalidPatternMessage="Le format du numéro de TVA est invalide."
            customErrorMessage="Le numéro de TVA ne correspond pas au siren."
          ></base-form-input>

          <base-form-input
            *ngIf="isExterne && isFrench"
            label="Code APE"
            controlName="codeApe"
            invalidPatternMessage="Le champ doit contenir exactement 4 chiffres et 1 lettre majuscule en fin de chaîne."
            [disabled]="isReadMode()"
          ></base-form-input>

          <mat-form-field class="example-chip-list" appearance="fill" style="width: 600px; max-width: 100%">
            <mat-label>Famille d'achat</mat-label>
            <mat-chip-list #chipList aria-label="Famille d'achat" [disabled]="isReadMode()">
              <mat-chip *ngFor="let item of form?.get('famillies')?.value" (removed)="remove(item)">
                {{ item.link }}
                <button matChipRemove *ngIf="!isReadMode()">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
              <input
                placeholder="Nouvelle famille"
                #itemInput
                [formControl]="itemCtrl"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (keydown)="onKeyDown($event)"
                [disabled]="isReadMode()"
              />
            </mat-chip-list>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" [disabled]="isReadMode()">
              <mat-option *ngFor="let item of filteredFamilies | async" [value]="item">
                {{ item?.link }}
              </mat-option>
            </mat-autocomplete>
            <div *ngIf="isDuplicate" style="color: red">Cette famille a déjà été sélectionnée.</div>
          </mat-form-field>

          <base-form-input
            *ngIf="isEtranger || (isExterne && !isFrench)"
            label="Identifiant entreprise"
            controlName="dunsNumber"
            [disabled]="isReadMode()"
          ></base-form-input>

          <p class="mb-3" *ngIf="showSupplierDetails">Adresse SIRET fournisseur</p>
          <mat-divider class="mb-6" *ngIf="showSupplierDetails"></mat-divider>

          <ng-container [formGroup]="addressForm" *ngIf="showSupplierDetails">
            <div class="flex flex-col sm:flex-row">
              <base-form-input
                class="w-full sm:w-1/2 sm:mr-3"
                label="Adresse"
                controlName="street"
                [disabled]="isReadMode()"
              ></base-form-input>

              <base-form-input
                class="w-full sm:w-1/2 sm:ml-3"
                label="Adresse additionnelle"
                controlName="additionalAddress"
                [disabled]="isReadMode()"
              ></base-form-input>
            </div>

            <div class="flex flex-col sm:flex-row">
              <base-form-input
                class="w-full sm:w-1/2 sm:mr-3"
                label="Code postal"
                controlName="postalCode"
                invalidPatternMessage="Le format du code postal est invalide."
                [disabled]="isReadMode()"
              ></base-form-input>
              <base-form-input
                class="w-full sm:w-1/2 sm:ml-3"
                label="Ville"
                controlName="city"
                [disabled]="isReadMode()"
              ></base-form-input>
            </div>
          </ng-container>

          <!-- Traitement facture PA/PREDIK360 (PRED-3268) : après la section adresse -->
          <ng-container *ngIf="showSupplierDetails">
            <base-form-input
              class="mb-2"
              [label]="ELECTRONIC_INVOICE_FIELD_LABEL"
              controlName="electronicInvoicePlatform"
              type="checkbox"
              [disabled]="isReadMode()"
            ></base-form-input>
            <!-- PRED-3272 : au passage à Conforme, un mail de confirmation part vers tous les contacts du fournisseur -->
            <p *ngIf="!isReadMode()" class="text-xs text-secondary mb-2">
              Au passage à « Conforme », un mail de confirmation de facturation via PA est envoyé à tous les contacts du
              fournisseur.
            </p>
          </ng-container>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button *ngIf="canCreateMode" type="button" mat-button (click)="resetSupplierForm()">RÉINITIALISER</button>
      <base-form-input
        type="submit"
        [mode]="mode"
        [loading]="loading"
        entityLabel="SUPPLIER"
        (onCreate)="createItem()"
        (onUpdate)="updateItem()"
      ></base-form-input>
    </mat-dialog-actions>
  </form>
</ng-container>

<ng-container *ngIf="canDeleteMode">
  <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
    <div>{{ data.name }}</div>
    <button type="button" mat-icon-button (click)="close()" tabindex="-1">
      <mat-icon [icIcon]="icClose"></mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <p>Etes-vous sûr de vouloir supprimer {{ data.name }} ?</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">NON</button>
    <button mat-button color="primary" (click)="deleteItem()">OUI</button>
  </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="canImportMode">
  <vex-form-import-base
    [modalTitle]="'Importer des fournisseurs'"
    [entityLabel]="'Fournisseur'"
    [form]="importForm"
    [loading]="loading"
    [service]="service"
    [mode]="mode"
    (saveForm)="save()"
    (importItems)="importItems()"
    [canDownloadTemplateModel]="authService.hasPermission(ENUM_PERMISSIONS.READ_SUPPLIER)"
  ></vex-form-import-base>
</ng-container>

<ng-container *ngIf="canArchiveMode">
  <form-modal-delete-base
    (onClose)="close()"
    (onDelete)="archiveItem()"
    title="{{ defaults?.isArchive ? 'Désarchiver' : 'Archiver' }} le fournisseur"
    defaultMessage="Êtes-vous sûr de vouloir {{ defaults?.isArchive ? 'désarchiver' : 'archiver' }} ce fournisseur ?"
  ></form-modal-delete-base>
</ng-container>

<!-- Liste des fammilles à renvoyer -->
<ng-template #customSelectDisplay let-element="element">
  <div *ngIf="element">
    <div class="flex flex-col mb-4" *ngFor="let item of element">
      {{ item?.link }}
    </div>
  </div>
</ng-template>
